import {
  createRouter,
  createWebHashHistory,
  // createWebHistory
} from 'vue-router'

import Index from '../pages/index/index.vue'
import UserCenter from '../pages/userCenter/index.vue'
import NoticeInfo from '../pages/noticeInfo/index.vue'
import Course from '../pages/course/index.vue'
import CourseDetail from '../pages/courseDetail/index.vue'
import Chapter from '../pages/chapter/index.vue'
import Search from '../pages/search/index.vue'
import ExamCenter from '../pages/examCenter/index.vue'
const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      title: '唯品会V学堂'
    }
  },
  {
    path: '/:target',
    name: 'TargetIndex',
    component: Index,
    meta: {
      title: '唯品会V学堂'
    }
  },
  {
    path: '/:target/userCenter',
    name: 'UserCenter',
    component: UserCenter,
    meta: {
      title: '用户中心-唯品会V学堂'
    }
  },
  {
    path: '/:target/notice/:id',
    name: 'NoticeInfo',
    component: NoticeInfo,
    meta: {
      title: '公告详情-唯品会V学堂'
    }
  },
  {
    path: '/:target/course',
    name: 'Course',
    component: Course,
    meta: {
      title: '课程-唯品会V学堂'
    }
  },
  {
    path: '/:target/courseOverview/:menuCategory/:categoryId',
    name: 'courseOverview',
    component: Course,
    meta: {
      title: '课程-唯品会V学堂'
    }
  },
  {
    path: '/:target/course/:courseId',
    name: 'CourseDetail',
    component: CourseDetail,
    meta: {
      title: '课程详情-唯品会V学堂'
    }
  },
  {
    path: '/:target/chapter/:courseId/:chapterId',
    name: 'ChapterDetail',
    component: Chapter,
    meta: {
      title: '课程详情-唯品会V学堂'
    }
  },
  {
    path: '/:target/search',
    name: 'Search',
    component: Search,
    meta: {
      title: '搜索-唯品会V学堂'
    }
  },
  {
    path: '/:target/examCenter',
    name: 'ExamCenter',
    component: ExamCenter,
    meta: {
      title: '考试中心-唯品会V学堂'
    }
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) {
    from.name ? next({name: from.name}) : next('/')
  } else {
    next()
  }
})

export default router
